import { INTERACTIVE_ELEMENTS_SELECTOR } from '../constants';

const getFocusableElements = (element: HTMLElement, customQuery?: string, onlyVisible?: boolean) =>
  Array.from<HTMLElement>(element.querySelectorAll(customQuery || INTERACTIVE_ELEMENTS_SELECTOR)).filter(
    (el) => !onlyVisible || el.offsetParent !== null,
  );

export default getFocusableElements;
